import { SignUp } from '@clerk/react';
import { clerkAppearance } from '../../theme/clerk-appearance';
import { AuthLayout } from './auth-layout';

export function SignUpPage() {
  return (
    <AuthLayout>
      <SignUp appearance={clerkAppearance} />
    </AuthLayout>
  );
}
